
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { IoAdd } from "react-icons/io5";
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FaMinusCircle, FaPlus  } from "react-icons/fa";
import { AddFoods } from '../services/foodsServices';
import { toast } from 'react-toastify';
import { fetchFood } from "../redux/slices/foodSlice";
import ButtonLoader from '../components/ButtonLoader';

export function AddFoodItem() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [imageFiles, setImageFiles] = useState([null, null, null, null]);
  const [category, setCategory] = useState('');
  const [loading, setLoading] = useState(false);

  const categories = useSelector((state) => state.category?.category?.data);

  useEffect(() => {
    if (categories?.length > 0) {
      const items = categories.map((item) => item.name);
      setCategory(items);
    }
  }, [categories]);

  useEffect(() =>{
    dispatch(fetchFood())
  }, [dispatch])


  const formik = useFormik({
    initialValues: {
        name: "",
        categoryId : 0,
        price: 0,
        description: "",
        ingredientDetails: "",
        duration: "",
        images: [],
        videos: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Name is required'),
      categoryId: Yup.string().required('category is required'),
      // price: Yup.number().required('Price is required').positive(),
      description: Yup.string().required('Description is required'),
      ingredientDetails: Yup.string().required('ingredientDetails is required'),
      duration: Yup.string().required('duration is required'),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("categoryId", values.categoryId);
      const numericPrice = values.price.replace(/₦/g, "");
      formData.append("price", numericPrice);
      formData.append("description", values.description);
      formData.append("ingredientDetails", values.ingredientDetails);
      formData.append("duration", values.duration);
    
      values.images.forEach((image, index) => {
        if (image) {
          formData.append(`images[${index}]`, image);
        }
      });
    
      const res = await AddFoods(formData);
      setLoading(true);

      if (res?.statusCode === 200) {
        toast.success(res?.message);
        dispatch(fetchFood());
        setLoading(false)
        setOpen(false);
      } else if (res?.statusCode === 203) {
        toast.error(res?.message);
        setLoading(false)
      } else if(res?.statusCode === 404){
        toast.error(res.message)
        setLoading(false)
      } else if(res?.statusCode === 999){
        toast.error(res.message)
        setLoading(false)
      } else {
        console.log(res.message);
      }
    }    
  })

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
  
      reader.onloadend = () => {
        const base64String = reader.result;
        let newImageFiles = [...imageFiles];
        newImageFiles[index] = base64String;
        setImageFiles(newImageFiles);
  
        let formImages = [...formik.values.images];
        formImages[index] = base64String; 
        formik.setFieldValue("images", formImages);
      };
  
      reader.readAsDataURL(file);
    }
  };  
  

  const deleteImage = (index) => {
    let newImageFiles = [...imageFiles];
    newImageFiles[index] = null;
    setImageFiles(newImageFiles);
  
    let formImages = [...formik.values.images];
    formImages[index] = null;
    formik.setFieldValue("images", formImages);
  };
  
  return (
    <div>
      <button onClick={() => setOpen(true)} className="bg-[#FFE6E6] hover:bg-opacity-50 py-2.5 px-4 flex items-center rounded-md text-sm justify-center outline-0 focuse:outline-0 border border-[#FFB0B0] text-primaryRed w-full">
          <IoAdd className="text-xl mr-1 md:mr-2 font-bold text-primaryRed" /> 
          <span className='text-xs sm:text-sm'>Add New Food Item</span>
      </button>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} size="md"
         slotProps={{
          root: {
            className: `
              backdrop-blur-[1px] 
              bg-orange/20 
              rounded-tl-2xl 
            `,
          },
        }}  
      >
        <ModalClose />
        <form onSubmit={formik.handleSubmit} className="p-6">
          <h1 className="capitalize text-[24px] font-bold text-primaryRed pt-4">Add New Food Item</h1>
          <h2 className="mb-6 mt-3 text-sm text-[#0A0A0ACC]">
          Add a new flavor to the menu! Fill in the details to introduce a fresh dish and keep customers coming back for more.        
          </h2>
          <div className="">
              <label>Select Menu</label>
              <div className="my-2">
                 <select
                  id="categoryId"
                  name="categoryId"
                  value={formik.values.categoryId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="border text-[#0A0A0A]/70 text-sm border-[#00000] border-opacity-40 outline-none ring-0 rounded-md px-4 w-full py-1.5"
                >
                  <option value="" className='text-xs text-[#0A0A0A]/50'>Select Menu</option>
                  {categories?.length > 0 ? (
                    categories.map((item) => (
                      <option key={item.id} value={item.id} className="text-sm text-[#0A0A0A]/80">
                        {item.name}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      No Menu available
                    </option>
                  )}
                </select>
                {formik.touched.categoryId && formik.errors.categoryId ? (
                  <div className="text-red-500 text-xs">{formik.errors.categoryId}</div>
                ) : null}
              </div>
            <div className="h-[1px] w-full border-0 bg-primaryGray my-5" />
            <h2 className="text-md pb-2">Food Item</h2>
            <p className="text-xs capitalize">add up to 4 new food items </p>
            <div className="px-4 py-2 rounded-2xl border my-3">
              <div  className="grid place-items-end">
                <p className="flex items-center text-primaryRed">
                  <IoAdd className="text-lg mr-1 font-bold text-primaryRed"/> 
                  <span className="text-xs">Create new food item</span>
                </p>
              </div>
              <div className="my-3">
                <label className='text-md'>Food Items Name</label>
                <input
                  type="text"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                   placeholder="Input for the food name (e.g., “Jollof Rice”)" 
                className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-0 ring-0 focus:outline-0 placeholder:text-xs px-3"
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-red-500 text-xs">{formik.errors.name}</div>
                ) : null}
              </div>
              <div className="mb-5">
                <label className='text-xs font-semibold py-4'>Add Image <span className="font-medium text-gray-500">(you can add up-to 4 images)</span></label>
                <div className="flex items-center justify-center gap-5 mt-4">
                  <div className="flex items-center justify-center flex-wrap lg:flex-nowrap px-4 gap-2">
                    {imageFiles?.map((imageFile, index) => (
                      <div key={index} className="relative w-[100px] lg:w-[72px] h-[100px] lg:h-[72px] flex flex-col items-center justify-center border rounded-md cursor-pointer overflow-hidden">
                        {!imageFile ? (
                          <>
                            <label className="relative w-[100px] lg:w-[72px] h-[100px] lg:h-[72px] flex flex-col items-center justify-center border rounded-md cursor-pointer overflow-hidden">
                              <div className="flex items-center justify-center gap-1">
                                <FaPlus className="text-gray-400 text-sm hover:text-gray-500" />
                                <span className="text-gray-500 text-sm hover:text-gray-700">
                                  {`img ${index + 1}`}
                                </span>
                              </div>
                              <input
                                type="file"
                                id={`image-${index}`}
                                name={`image-${index}`}
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, index)}
                                className="hidden w-[50px] h-[30px] rounded-xl"
                              />
                            </label>
                          </>
                        ) : (
                          <>
                            <div className="relative h-full text-xs">
                              <img src={imageFile} alt={`Preview ${index + 1}`} />
                              <button
                                className="absolute top-0 right-0 outline-0 duration-500 transition-all ease-in-out"
                                onClick={() => deleteImage(index)}
                              >
                                <FaMinusCircle className="text-md font-bold text-primaryRed" />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="my-3">
                <label className="text-md py-2">Price</label>
                <input
                  name="price"
                  value={formik.values.price}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const numericValue = inputValue.replace(/[^0-9]/g, "");
                    const formattedValue = numericValue ? `₦${numericValue}` : "";
                    formik.setFieldValue("price", formattedValue);
                  }}
                  onBlur={formik.handleBlur}
                  placeholder="Input for the item price in Naira (e.g., “₦1500”)."
                  className="border rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-0 ring-0 focus:outline-0 placeholder:text-xs px-3"
                />
                {formik.touched.price && formik.errors.price ? (
                  <p className="text-red-500 text-xs">{formik.errors.price}</p>
                ) : null}
              </div>
              <div className="my-3">
                <label className='text-md py-2'>Food Description</label>
                <input
                 type="text"
                 id="description"
                 name="description"
                 value={formik.values.description}
                 onChange={formik.handleChange}
                 onBlur={formik.handleBlur}
                 placeholder="Short description to describe the food (e.g., “Spicy, flavorful rice cooked in tomato sauce”)." 
                 className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-0 ring-0 focus:outline-0 placeholder:text-xs px-3"
               />
               {formik.touched.description && formik.errors.description ? (
                  <div className="text-red-500 text-xs">{formik.errors.description}</div>
                ) : null}
              </div>
              <div className="my-3">
                <label className='text-md py-2'>Ingredient Details</label>
                <input
                 type="text"
                 id="ingredientDetails"
                 name="ingredientDetails"
                 value={formik.values.ingredientDetails}
                 onChange={formik.handleChange}
                 onBlur={formik.handleBlur}
                 placeholder="Ingredient Details." 
                 className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-0 ring-0 focus:outline-0 placeholder:text-xs px-3"
               />
               {formik.touched.ingredientDetails && formik.errors.ingredientDetails ? (
                  <div className="text-red-500 text-xs">{formik.errors.ingredientDetails}</div>
                ) : null}
              </div>
              <div className="my-3">
                <label className='text-md py-2'>Duration</label>
                <input
                 type="text"
                 id="duration"
                 name="duration"
                 value={formik.values.duration}
                 onChange={formik.handleChange}
                 onBlur={formik.handleBlur}
                 placeholder="2hrs 30mins" 
                 className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-0 ring-0 focus:outline-0 placeholder:text-xs px-3"
               />
               {formik.touched.duration && formik.errors.duration ? (
                  <div className="text-red-500 text-xs">{formik.errors.duration}</div>
                ) : null}
              </div>
            </div>
            <div className="flex items-center gap-10 justify-between mt-4">
            <button
              onClick={() => setOpen(false)}
                className="text-primaryRed bg-white w-full px-4 py-2 rounded-md outline-none ring-0 border border-[#FFB0B0] text-md hover:outline-none capitalize mt-6 focus:outline-none focus:border-primaryRed hover:bg-[#FFB0B0]"
              >Cancel </button>
              <button
                type="submit"
                disabled={loading}
                className="bg-[#FF0000] hover:bg-primaryRed/80 text-white text-md w-full px-4 py-2 rounded-md outline-none ring-0 border border-primaryRed hover:text-white capitalize mt-6 focus:outline-none focus:border-primaryRed hover:border-PrimaryRed"
                >
                {loading ? <ButtonLoader />
                  : <span> save</span>
                  } 
              </button> 
            </div>
          </div>
        </form>  
      </Drawer>
    </div>
  );
}
